import { render, staticRenderFns } from "./TransactionsPage.vue?vue&type=template&id=828d73a2&scoped=true&"
import script from "./TransactionsPage.vue?vue&type=script&lang=ts&"
export * from "./TransactionsPage.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionsPage.vue?vue&type=style&index=0&id=828d73a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828d73a2",
  null
  
)

export default component.exports